import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { GridFilter, LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { HrmPayCurentYearMonthComponent } from "../../hrm-pay-curent-year-month/hrm-pay-curent-year-month.component";
import { Element } from "../../models/base-info/element.model";
import { ElementGroup } from "../../models/enums/element-group";
import { ElemntshowKind } from "../../models/enums/elemntshow-kind";

@Component({
  selector: "ngx-monthly-work-information",
  templateUrl: "./monthly-work-information.component.html",
  styleUrls: ["./monthly-work-information.component.scss"],
})
export class MonthlyWorkInformationComponent extends BaseFormComponent<any> {
  public dColumns: form_control[] = [];
  activeElement: Element[];
  loadingIndicator: boolean;
  inputEditorform: any;
  editingName: { name: string };
  MonthlyWorkInformations: any[];
  ElementGroupCodes: number[] = [];
  isLoading: boolean = false;
  constructor(
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    __id: FormContainerModel,
    _tabsservice: TabularService,
    private lookupservice: LookupService
  ) {
    super(selectorService, cd);
    this._id = __id;
    this.tabsservice = _tabsservice;
  }
  async ngOnInit() {
    this.apiName = "MonthlyWorkInformation";
    this.areaName = "Payroll";
    this.label = "اطلاعات ماهانه";
    this.lookupservice
      .getLookupbyCategory("HRM", "ElementGroup")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        this.activeElement = data.filter((x) => x.Code <= ElementGroup.Other && x.Code !== ElementGroup.Loan).sort((a, b) => a.Code - b.Code) as [];
      });
    this.setColumns();
    this.setFormGroup({});
    this.setdefault();
    this.loadData();
  }
  setdefault() {
    super.setdefault();
    this.ElementGroupCodes = [];
    this.ElementGroupCodes.push(ElementGroup.Bonus);
    this.ElementGroupCodes.push(ElementGroup.Deduct);
    this.ElementGroupCodes.push(ElementGroup.Boss);
    this.ElementGroupCodes.push(ElementGroup.Work);
    this.ElementGroupCodes.push(ElementGroup.Other);
    if (this.accountService.authService.getHrmPayCurentYearMonth()) {
      this.setValue("IssueYear", this.accountService.authService.getHrmPayCurentYearMonth().CurentYear);
      this.setValue("IssueMonth", this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth);
      this.setValue("EffectYear", this.accountService.authService.getHrmPayCurentYearMonth().CurentYear);
      this.setValue("EffectMonth", this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth);
    }
  }
  setHrmPayCurentYearMonth() {
    this.dialogService
      .open(
        HrmPayCurentYearMonthComponent,
        {
          areaName: this.areaName,
          label: this.label,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        this.ngOnInit();
      });
  }
  loadData() {
    let filter: GridFilter[] = [];
    if (
      !this.formGroup ||
      this.isLoading ||
      !this.formGroup.get("IssueYear").value ||
      this.formGroup.get("IssueYear").value === null ||
      !this.formGroup.get("IssueMonth").value ||
      this.formGroup.get("IssueMonth").value === null
    )
      return;
    if (!this.accountService.authService.getHrmPayCurentYearMonth()) this.setHrmPayCurentYearMonth();

    filter.push({ Type: "F", Filed: "ElementGroupCodes", Value: this.ElementGroupCodes, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    filter.push({ Type: "F", Filed: "IssueYear", Value: this.formGroup.get("IssueYear").value, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    filter.push({ Type: "F", Filed: "IssueMonth", Value: this.formGroup.get("IssueMonth").value, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    filter.push({ Type: "F", Filed: "EffectYear", Value: this.formGroup.get("EffectYear").value, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    filter.push({ Type: "F", Filed: "EffectMonth", Value: this.formGroup.get("EffectMonth").value, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
    filter.push({ Type: "S", Filed: "PersCode", Value: 0, Logic: "and", Operator: "asc", Skip: 0, Take: 0 });

    this.isLoading = true;
    this.httpCommonService
      .create(this.apiName + "/MonthlyInformations", filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          this.isLoading = false;
          this.MonthlyWorkInformations = x as [];
        },
        (error) => (this.isLoading = false)
      );
  }
  async setColumns() {
    let filter: GridFilter[] = [];
    filter.push({ Type: "F", Filed: "ElementGroupCodes", Value: this.ElementGroupCodes, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });

    if (this.formGroup) {
      filter.push({ Type: "F", Filed: "IssueYear", Value: this.formGroup.get("IssueYear").value, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
      filter.push({ Type: "F", Filed: "IssueMonth", Value: this.formGroup.get("IssueMonth").value, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
      filter.push({ Type: "F", Filed: "EffectYear", Value: this.formGroup.get("EffectYear").value, Logic: "and", Operator: "eq", Skip: 0, Take: 0 });
      filter.push({
        Type: "F",
        Filed: "EffectMonth",
        Value: this.formGroup.get("EffectMonth").value,
        Logic: "and",
        Operator: "eq",
        Skip: 0,
        Take: 0,
      });
    }
    let _columns = [];
    _columns.push(<form_control>{
      label: "نوع عامل",
      controlType: FormControlTypes.checkboxList,
      modelName: "ElementGroupCodes",
      userClass: "select-shr",
      disabled: false,
      name: "ElementGroupCodes",
      order: 0,
      textType: "text",
      columnNumber: 5,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    _columns.push(<form_control>{
      label: "سال جاری",
      controlType: FormControlTypes.dropdown,
      modelName: "IssueYear",
      userClass: "select-shr",
      disabled: false,
      name: "IssueYear",
      order: 1,
      textType: "text",
      columnNumber: 1,
      isFloat: 1,
      formVisible: true,
      listVisible: true,
      required: true,
      apiName: "FiscalYear/FiscalYear",
      valueMember: "Year",
      displayMember: "Year",
    });
    _columns.push(<form_control>{
      label: "ماه جاری",
      controlType: FormControlTypes.dropdown,
      modelName: "IssueMonth",
      userClass: "select-shr",
      disabled: false,
      name: "IssueMonth",
      order: 2,
      textType: "text",
      columnNumber: 2,
      isFloat: 1,
      formVisible: true,
      listVisible: true,
      required: true,
      apiName: "MonthsName",
      valueMember: "Id",
      displayMember: "Title",
    });
    _columns.push(<form_control>{
      label: "سال اجرا",
      controlType: FormControlTypes.dropdown,
      modelName: "EffectYear",
      userClass: "select-shr",
      disabled: false,
      name: "EffectYear",
      order: 3,
      textType: "text",
      columnNumber: 3,
      isFloat: 1,
      formVisible: true,
      listVisible: true,
      required: true,
      apiName: "FiscalYear/FiscalYear",
      valueMember: "Year",
      displayMember: "Year",
    });
    _columns.push(<form_control>{
      label: "ماه اجرا",
      controlType: FormControlTypes.dropdown,
      modelName: "EffectMonth",
      userClass: "select-shr",
      disabled: false,
      name: "EffectMonth",
      order: 4,
      textType: "text",
      columnNumber: 4,
      isFloat: 1,
      formVisible: true,
      listVisible: true,
      required: true,
      apiName: "MonthsName",
      valueMember: "Id",
      displayMember: "Title",
    });
    this.columns = _columns;
    this.orignalColumns = _columns;
    let _dColumns = [];
    _dColumns.push(<form_control>{
      label: "محاسبه",
      controlType: FormControlTypes.checkbox,
      modelName: "HasCalculate",
      disabled: true,
      name: "HasCalculate",
      order: 0,
      textType: "checkbox",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "سریال",
      controlType: FormControlTypes.textbox,
      modelName: "Id",
      disabled: true,
      name: "Id",
      order: 1,
      textType: "number",
      formVisible: false,
      listVisible: false,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "کارمند",
      controlType: FormControlTypes.textbox,
      modelName: "HrmPersonnelId",
      disabled: true,
      name: "HrmPersonnelId",
      order: 2,
      textType: "number",
      formVisible: false,
      listVisible: false,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "سال جاری",
      controlType: FormControlTypes.textbox,
      modelName: "IssueYear",
      disabled: true,
      name: "IssueYear",
      order: 3,
      textType: "number",
      formVisible: false,
      listVisible: false,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "ماه جاری",
      controlType: FormControlTypes.textbox,
      modelName: "IssueMonth",
      disabled: true,
      name: "IssueMonth",
      order: 4,
      textType: "number",
      formVisible: false,
      listVisible: false,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "سال اجرا",
      controlType: FormControlTypes.textbox,
      modelName: "EffectYear",
      disabled: true,
      name: "EffectYear",
      order: 5,
      textType: "number",
      formVisible: false,
      listVisible: false,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "ماه اجرا",
      controlType: FormControlTypes.textbox,
      modelName: "EffectMonth",
      disabled: true,
      name: "EffectMonth",
      order: 6,
      textType: "number",
      formVisible: false,
      listVisible: false,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "کد پرسنلی",
      controlType: FormControlTypes.textbox,
      modelName: "PersCode",
      columnWidth: 100,
      disabled: true,
      name: "PersCode",
      order: 7,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "نام",
      controlType: FormControlTypes.textbox,
      modelName: "FirstName",
      disabled: true,
      columnWidth: 100,
      name: "FirstName",
      order: 8,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "نام خانوادگی",
      controlType: FormControlTypes.textbox,
      modelName: "LastName",
      columnWidth: 100,
      disabled: true,
      name: "LastName",
      order: 9,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "نوع استخدام",
      controlType: FormControlTypes.textbox,
      modelName: "EmploymentKindTitle",
      columnWidth: 100,
      disabled: true,
      name: "EmploymentKindTitle",
      order: 10,
      textType: "text",
      formVisible: false,
      listVisible: true,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "محل خدمت",
      controlType: FormControlTypes.textbox,
      modelName: "WorkplaceTitle",
      columnWidth: 100,
      disabled: true,
      name: "WorkplaceTitle",
      order: 11,
      textType: "text",
      formVisible: true,
      listVisible: false,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "مرکز هزینه",
      controlType: FormControlTypes.textbox,
      modelName: "CostCenterTitle",
      columnWidth: 100,
      disabled: true,
      name: "CostCenterTitle",
      order: 12,
      textType: "text",
      formVisible: true,
      listVisible: false,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "سال جاری حکم",
      controlType: FormControlTypes.textbox,
      modelName: "HrnIssueYear",
      disabled: true,
      name: "HrnIssueYear",
      order: 3,
      textType: "number",
      formVisible: false,
      listVisible: false,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "ماه جاری حکم",
      controlType: FormControlTypes.textbox,
      modelName: "HrnIssueMonth",
      disabled: true,
      name: "HrnIssueMonth",
      order: 4,
      textType: "number",
      formVisible: false,
      listVisible: false,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "روز جاری حکم",
      controlType: FormControlTypes.textbox,
      modelName: "HrnIssueDay",
      disabled: true,
      name: "HrnIssueDay",
      order: 4,
      textType: "number",
      formVisible: false,
      listVisible: false,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "سال اجرا حکم",
      controlType: FormControlTypes.textbox,
      modelName: "HrnEffectYear",
      disabled: true,
      name: "HrnEffectYear",
      order: 5,
      textType: "number",
      formVisible: false,
      listVisible: false,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "ماه اجرا حکم",
      controlType: FormControlTypes.textbox,
      modelName: "HrnEffectMonth",
      disabled: true,
      name: "HrnEffectMonth",
      order: 6,
      textType: "number",
      formVisible: false,
      listVisible: false,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "روز اجرا حکم",
      controlType: FormControlTypes.textbox,
      modelName: "HrnEffectDay",
      disabled: true,
      name: "HrnEffectDay",
      order: 6,
      textType: "number",
      formVisible: false,
      listVisible: false,
      required: false,
    });
    _dColumns.push(<form_control>{
      label: "وضعیت حکم",
      controlType: FormControlTypes.textbox,
      modelName: "NotificationStatusKindCode",
      disabled: true,
      name: "NotificationStatusKindCode",
      order: 6,
      textType: "number",
      formVisible: false,
      listVisible: false,
      required: false,
    });

    let cCount = 12;
    this.httpCommonService
      .create("MonthlyWorkInformation/GetActiveElement", filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x: Element[]) => {
        if (x) {
          this.activeElement = x.sort((a, b) => a.ElementGroupCode - b.ElementGroupCode);
          this.activeElement.forEach((e) => {
            cCount = cCount + 1;
            if (e.ElementGroupCode === ElementGroup.Work) {
              if (e.ElemntshowKindCode === ElemntshowKind.DDHHMM)
                _dColumns.push(<form_control>{
                  label: e.Title,
                  inputMask: "00:00:00",
                  columnWidth: 100,
                  controlType: FormControlTypes.textbox,
                  modelName: `MW_${e.Id}`,
                  disabled: false,
                  name: `MW_${e.Id}`,
                  order: cCount,
                  textType: "number",
                  withComma: true,
                  formVisible: true,
                  listVisible: true,
                  required: false,
                  format: "00:00",
                });
              else if (e.ElemntshowKindCode === ElemntshowKind.HHMM)
                _dColumns.push(<form_control>{
                  label: e.Title,
                  inputMask: "000:00",
                  columnWidth: 100,
                  controlType: FormControlTypes.textbox,
                  modelName: `MW_${e.Id}`,
                  disabled: false,
                  name: `MW_${e.Id}`,
                  order: cCount,
                  textType: "number",
                  withComma: true,
                  formVisible: true,
                  listVisible: true,
                  required: false,
                  format: "00:00",
                });
              else if (e.ElemntshowKindCode === ElemntshowKind.DD)
                _dColumns.push(<form_control>{
                  label: e.Title,
                  inputMask: "00",
                  columnWidth: 100,
                  controlType: FormControlTypes.textbox,
                  modelName: `MW_${e.Id}`,
                  disabled: false,
                  name: `MW_${e.Id}`,
                  order: cCount,
                  textType: "number",
                  withComma: true,
                  formVisible: true,
                  listVisible: true,
                  required: false,
                  format: "00:00",
                });
              else
                _dColumns.push(<form_control>{
                  label: e.Title,
                  controlType: FormControlTypes.textbox,
                  columnWidth: 100,
                  modelName: `MW_${e.Id}`,
                  disabled: false,
                  name: `MW_${e.Id}`,
                  order: cCount,
                  textType: "number",
                  withComma: true,
                  formVisible: true,
                  listVisible: true,
                  required: false,
                  format: "00:00",
                });
            } else
              _dColumns.push(<form_control>{
                label: e.Title,
                controlType: FormControlTypes.textbox,
                columnWidth: 100,
                modelName: `MW_${e.Id}`,
                disabled: false,
                name: `MW_${e.Id}`,
                order: cCount,
                textType: "number",
                withComma: true,
                formVisible: true,
                listVisible: true,
                required: false,
                format: "#,#",
              });
          });

          this.dColumns = _dColumns;
        }
      });
  }
  addControl() {
    this.setValue("ElementGroupCodes", this.ElementGroupCodes);
    this.cd.markForCheck();
  }
  change($event) {
    this.ElementGroupCodes = this.formGroup.get("ElementGroupCodes").value;
    this.setColumns();
    this.loadData();
  }
  onValueChangeByApiName($event) {
    if ($event && $event.apiName) {
      if ($event.KeyName === "IssueYear") this.setValue("EffectYear", $event.data.Year);
      if ($event.KeyName === "IssueMonth") this.setValue("EffectMonth", $event.data.Id);

      this.loadData();
    }
  }
  onValueChanges(entity: any) {
    if (entity) {
      if (!entity.IssueYear) entity.IssueYear = this.formGroup.get("IssueYear").value;
      if (!entity.IssueMonth) entity.IssueMonth = this.formGroup.get("IssueMonth").value;
      if (!entity.EffectYear) entity.EffectYear = this.formGroup.get("EffectYear").value;
      if (!entity.EffectMonth) entity.EffectMonth = this.formGroup.get("EffectMonth").value;

      this.httpCommonService
        .create("MonthlyWorkInformation/UnPivotAndSave", entity)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            if (x) {
            }
          },
          (error) => this.sts.showDialog(`${Utilities.getHttpResponseMessage(error)}`, "پیغام خطا")
        );
    }
  }
}
